<script lang="ts"></script>

<h2 class="text-headline-line">
    Sold out!
</h2>

<p>
    Unfortunately all our spots are sold out and the waitinglist is also filled.<br>
    You may check back later or follow our socials to know when a spot frees up. Buying a ticket off of someone else is also possible.
</p>